import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { InternalReportConfigResponse } from '../../responses/business-intelligence/internal-report-config.response';
import { InternalReportProfileResponse } from '../../responses/business-intelligence/internal-report-profile.response';
import { ListInternalReportProfileResponse } from '../../responses/business-intelligence/list-internal-report-profile.response';
import { ReportPreviewAccessResponse } from '../../responses/business-intelligence/report-preview-access.response';
import { ReportConfigResponse } from '../../responses/business-intelligence/report-config.response';
@Injectable({
    providedIn: 'root'
})
export class ReportHealthUnitService extends CommonService {

    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
        super(configService);
    }
    public base_uri: string = `ReportHealthUnit`;

    public getByReport(idReport: number): Observable<ReportPreviewAccessResponse> {
        let uri = this.base_uri + `/idReport/${idReport}`

        return this.httpClient.get<ReportPreviewAccessResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBusinessIntelligence) + uri, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            )
    }

    public getReport(idReportFunctionHealthUnit: number): Observable<ReportConfigResponse> {
        console.log(idReportFunctionHealthUnit);
        let uri = this.base_uri + `/idReportFunctionHealthUnit/${idReportFunctionHealthUnit}`
        return this.httpClient.get<ReportConfigResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiBusinessIntelligence) + uri, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            )
    }
}
